import React, { memo } from 'react';
import {
	Route,
	Switch,
	useRouteMatch
} from 'react-router-dom';

import { log } from '../../../../services/utils';

import { useAuthState } from '../../../../contexts/AuthContext';
import { Provider as ProgramsProvider } from '../../../../contexts/ProgramsContext';
import { Provider as SubmissionsProvider } from '../../../../contexts/SubmissionsContext';

import ProgramList from './ProgramList';
import ProgramDetails from './ProgramDetails';
import TemplateDetails from './ProgramDetails/TemplateDetails';

const Programs = () => {
	let { path } = useRouteMatch();

	const { user: { permissions } } = useAuthState();

	return (
		<ProgramsProvider>
			<SubmissionsProvider>
				{ log( 'programs' ) }
				<Switch>
					{ permissions.addPrograms.isAvailable && permissions.addPrograms.canExecute
					|| permissions.viewPrograms.isAvailable && permissions.viewPrograms.canExecute
					|| permissions.editPrograms.isAvailable && permissions.editPrograms.canExecute
						?							<Route
							exact
							path={ `${ path }/:id` }
							component={ ProgramDetails }
						/>
						: null
					}

					<Route
						exact
						path={ `${ path }/:id/templates/:templateId` }
						component={ TemplateDetails }
					/>
					<Route
						exact
						path={ path }
						component={ ProgramList }
					/>
				</Switch>
			</SubmissionsProvider>
		</ProgramsProvider>
	);
};

export default memo( Programs );
